// Reemplaza tokens {key} en `text` con data[key]. Si una key no resuelve
// (tenant sin esa tenant_text seedeada), se vacía — antes dejaba el `{key}`
// literal visible en el PDF. Decisión 2026-06-20: UX más limpia, sin
// placeholders crudos. Si un template necesita un placeholder visible, debe
// usar texto fijo, no un token sin resolver.
export const replaceVariables = (text, data) => {
  if (!text || typeof text !== 'string') return text ?? '';
  return text.replace(/\{(\w+)\}/g, (_, key) => {
    const value = data?.[key];
    return value === undefined || value === null ? '' : String(value);
  });
};
